// 日本語の文言。キーを追加する際は各言語ファイルで構造を揃えること。
import type { Messages } from "./zh-CN";

const jaJP: Messages = {
  common: {
    language: "言語",
    confirm: "確認",
    cancel: "キャンセル",
    save: "保存",
    delete: "削除",
    edit: "編集",
    search: "検索",
    loading: "読み込み中…",
    empty: "データがありません",
  },
  nav: {
    workbench: "ワークベンチ",
    platform: "プラットフォーム",
    myProjects: "マイプロジェクト",
    overview: "概要",
    summarySettings: "要約設定",
    growth: "グロース",
    projectSettings: "プロジェクト設定",
    account: "アカウント設定",
    aiCapability: "AI 機能",
    dataGrowth: "データと成長",
    dataAccount: "データと会計",
    accessHelp: "導入とヘルプ",
    admin: "管理コンソール",
    home: "ホーム",
    knowledge: "ナレッジベース",
    agents: "エージェント",
    aiChat: "チャットとウィジェット",
    podcast: "AI ポッドキャスト",
    mcp: "MCP サービス",
    models: "モデルセンター",
    analytics: "サイト分析",
    agentAudit: "エージェント監査",
    chatHistory: "チャット履歴",
    tokenUsage: "消費記録",
    myOrders: "注文履歴",
    invitation: "招待",
    codeGenerator: "サイト導入",
    api: "チャット API",
    docs: "ドキュメント",
    about: "私たちについて",
  },
  admin: {
    userManagement: "ユーザー管理",
    productManagement: "商品管理",
    orderManagement: "注文管理",
    redeemCode: "引換コード生成",
    dataControl: "データ管理",
    modelGateway: "モデルゲートウェイ",
    systemSettings: "システム設定",
  },
  user: {
    settings: "ユーザー設定",
    orders: "注文履歴",
    usage: "消費記録",
    logout: "ログアウト",
  },
  mcpServer: {
    needVip: "MCP クライアント機能を利用するには年額会員の登録が必要です",
    vipDesc: "年額会員にアップグレードすると、MCP クライアント機能でサードパーティのツールに接続できます",
    backHome: "ホームに戻って会員登録",
    serverTab: "MCP サーバー",
    clientTab: "MCP クライアント",
  },
  payment: {
    invalidRedeem: "有効な引換コードを入力してください",
    redeemSuccess: "引き換えに成功しました",
  },
  modelCenter: {
    type: { chat: "チャット", embedding: "ベクトル", rerank: "リランク", image: "画像" },
    filterAll: "すべて",
    filterTools: "ツール呼び出し",
    filterImage: "画像",
    empty: "条件に一致するモデルがありません",
    modelN: "モデル {{id}}",
    default: "デフォルト",
    basicChat: "基本チャット",
    context: "コンテキスト",
    maxOutput: "最大出力",
    pendingPrice: "価格未定",
    input: "入力",
    output: "出力",
    fetchFailed: "モデル一覧の取得に失敗しました",
    fetchFailedRetry: "モデル一覧の取得に失敗しました。後ほど再試行してください",
  },
  oauth: {
    noCode: "認証に失敗しました：認証コードを取得できませんでした",
    loginSuccess: "{{provider}}のログインに成功しました！",
    bindSuccess: "{{provider}}アカウントの連携に成功しました",
    opFailed: "{{provider}}の操作に失敗しました",
    opFailedRetry: "{{provider}}の操作に失敗しました。再試行してください",
    processing: "{{provider}}のログインを処理しています...",
  },
  auth: {
    email: "メールアドレス",
    password: "パスワード",
    confirmPassword: "パスワードの確認",
    newPassword: "新しいパスワード",
    confirmNewPassword: "新しいパスワードの確認",
    verifyCode: "認証コード",
    emailVerifyCode: "メール認証コード",
    imageCaptcha: "画像認証コード",
    passkeyLogin: "パスキーでログイン",
    passwordLogin: "パスワードでログイン",
    usePassword: "パスワードでログイン",
    usePasskey: "パスキーでログイン",
    register: "登録",
    registerTitle: "アカウント登録",
    resetTitle: "パスワードのリセット",
    resetPassword: "パスワードをリセット",
    noAccount: "アカウントをお持ちでないですか？今すぐ登録",
    haveAccount: "アカウントをお持ちですか？今すぐログイン",
    forgotPassword: "パスワードをお忘れですか？",
    backToLogin: "ログインに戻る",
    sendCode: "認証コードを送信",
    getCaptcha: "認証コードを取得",
    retryAfter: "{{n}}秒後に再試行",
    otherLogin: "その他のログイン方法",
    githubLogin: "GitHub でログイン",
    qqLogin: "QQ でログイン",
    legacyTip: "旧版の要約 AI と PostChat システムのユーザーは、登録不要で QQ から直接ログインしてください",
    autoReturnTip: "ログイン後、以前閲覧していたページに自動的に戻ります",
    autoLoggingIn: "ログイン中です。お待ちください...",
    captchaAlt: "認証コード",
    operatedBy: "北京洪絵科技店（個人事業主）が運営",
    userAgreement: "利用規約",
    privacy: "プライバシーポリシー",
    rules: {
      requiredEmail: "メールアドレスを入力してください",
      invalidEmail: "有効なメールアドレスを入力してください",
      requiredPassword: "パスワードを入力してください",
      requiredVerifyCode: "認証コードを入力してください",
      requiredEmailCode: "メール認証コードを入力してください",
      requiredCaptcha: "画像認証コードを入力してください",
      requiredConfirm: "パスワードを確認してください",
      requiredNewPassword: "新しいパスワードを入力してください",
      requiredConfirmNew: "新しいパスワードを確認してください",
      passwordMin8: "パスワードは 8 文字以上にしてください",
      passwordMin6: "パスワードは 6 文字以上にしてください",
      passwordPattern: "パスワードには英字と数字を含めてください",
      passwordMismatch: "入力したパスワードが一致しません",
    },
    msg: {
      enterEmailFirst: "先にメールアドレスを入力してください",
      passkeyFailed: "パスキーのログインに失敗しました",
      passkeyVerifyFailed: "パスキーの認証に失敗しました",
      passkeyTryPassword: "パスキーのログインに失敗しました。パスワードでログインをお試しください",
      opCancelled: "操作がキャンセルされたか、権限がありません",
      securityError: "セキュリティエラー。クロスオリジンの問題の可能性があります",
      opAborted: "操作が中断されました",
      loginSuccessConsole: "ログインに成功しました。コンソールに移動しています",
      loginSuccessBack: "ログインに成功しました。以前のページに戻っています",
      linkInvalid: "ログインリンクが無効です。再取得してください",
      linkExpired: "ログインリンクの有効期限が切れました。再取得してください",
      loginFailedManual: "ログインに失敗しました。手動でログインをお試しください",
      tooManyAttempts: "ログイン試行回数が多すぎます。後ほど再試行してください",
      wrongCredentials: "ユーザー名またはパスワードが正しくありません",
      enterValidEmailPwd: "正しいメールアドレスとパスワードを入力してください",
      loginFailedRetry: "ログインに失敗しました。再試行してください",
      loginFailed: "ログインに失敗しました",
      systemError: "システムエラー。後ほど再試行してください",
      registerSuccess: "登録に成功しました！",
      registerFailed: "登録に失敗しました",
      codeSent: "認証コードを送信しました",
      sendCodeFailed: "認証コードの送信に失敗しました",
      captchaFailed: "認証コードの取得に失敗しました",
      resetSuccess: "パスワードのリセットに成功しました！",
      resetFailed: "パスワードのリセットに失敗しました",
      resetFailedRetry: "パスワードのリセットに失敗しました。再試行してください",
    },
  },
  siteWorkspace: {
    back: "すべてのサイト", aria: "サイト機能", overview: "概要", copilot: "Copilot", playbook: "プレイブック", knowledge: "ナレッジ", abilities: "機能", test: "テスト", appearance: "外観", analytics: "分析", settings: "設定", publish: "公開センター",
    common: { retry: "再試行", draft: "下書き", published: "公開済み", healthy: "正常", degraded: "縮退中", confirmRequired: "実行前に確認", noData: "データなし" },
    risk: { read: "読み取り専用", draft: "下書き", write: "書き込み", sensitive: "機密", financial: "金融", irreversible: "取り消し不可" },
    release: { ownerCanary: "管理者のみ", percent1: "訪問者の1%", percent10: "訪問者の10%", percent50: "訪問者の50%", all: "すべての訪問者" },
  },
};

export default jaJP;
